module.exports = __webpack_public_path__ + "img/goast.36d5c711.svg";